import { gql } from '@apollo/client';

export const REQUIRED_DOCUMENT_DELETED = gql`
  subscription requiredDocumentDeleted {
    requiredDocumentDeleted {
      requiredDocumentId
    }
  }
`;
